import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExperimentKeys } from '../ExperimentKeys';
import { getHasExposureBeenTracked } from '../useExperiment';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import { Data } from '../../signup-data/DATA';
import { getIsActiveAndAssignedToVariantACQ129 } from '../../store/experiments/selectors';
import { FlowActionTypes } from '../../store/flow/action-types';
import { fetchProductsForPricing, fetchPromotionsForPricing } from '../../store/pricing/action-creators';
import { isSignupDataCompleted } from '../../store/signup-data/selectors';
import { getTracker } from '../../tracking/getTracker';
import { Step } from '../../views/Step';
import { getNextSteps } from '../../store/flow/selectors';
import { setHasSignupInitiatedBeenTracked } from '../../tracking/useTrackSignupInitiated';
export const useAcq129ResetSignupTypeAndSignupInitiated = () => {
  useEffect(() => {
    getTracker().setProperties({
      signupType: null
    });
    setHasSignupInitiatedBeenTracked(false);
  });
};
export const useFlowPreviousStatesForAcq129 = () => {
  const dispatch = useDispatch();
  const {
    currentStep
  } = useCurrentStep();
  const isPricingPathSelected = useSelector(state => isSignupDataCompleted(state, Data.PricingPath));
  const isTrialSelected = useSelector(state => isSignupDataCompleted(state, Data.TrialName));
  const nextSteps = useSelector(getNextSteps);
  const isAcq129Variant = useSelector(getIsActiveAndAssignedToVariantACQ129);
  const isOnLandingPage = [Step.LandingPage].includes(currentStep);
  useEffect(() => {
    if (isAcq129Variant && isOnLandingPage && isPricingPathSelected) {
      if (isTrialSelected) {
        dispatch({
          type: FlowActionTypes.UpdatePreviousFlowStates,
          previousFlowStates: [{
            completedStep: Step.Pricing,
            nextSteps: [Step.TrialPicker, currentStep, ...nextSteps]
          }, {
            completedStep: Step.TrialPicker,
            nextSteps: [currentStep, ...nextSteps]
          }]
        });
      } else {
        dispatch({
          type: FlowActionTypes.UpdatePreviousFlowStates,
          previousFlowStates: [{
            completedStep: Step.Pricing,
            nextSteps: [currentStep, ...nextSteps]
          }]
        });
      }
    }
  }, [isTrialSelected, isPricingPathSelected, isOnLandingPage, nextSteps, currentStep, dispatch, isAcq129Variant]);
};
export const useAcq129 = () => {
  const dispatch = useDispatch();
  const isAcq129Variant = useSelector(getIsActiveAndAssignedToVariantACQ129);
  const hasExposureBeenTrackedForAcq129 = getHasExposureBeenTracked(ExperimentKeys.ACQ129);

  if (isAcq129Variant && !hasExposureBeenTrackedForAcq129) {
    dispatch(fetchProductsForPricing());
    dispatch(fetchPromotionsForPricing());
    getTracker().setProperties({
      signupType: null
    });
  }
};